module.exports = __webpack_public_path__ + "img/img39.5223ad87.png";